import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { modalTitleStyles } from 'asterX-UI/Modals/modals.styles'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import { IconCloseButton } from 'asterX-UI/Buttons'
import PropTypes from 'prop-types'

const ModalTitle = withStyles(modalTitleStyles)(props => {
  const { children, classes, onClose, disableBtn = false, ...other } = props

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant={'subtitle1'}>{children}</Typography>
      {onClose
        ? !disableBtn && (
            <IconCloseButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
            />
          )
        : null}
    </MuiDialogTitle>
  )
})
export default ModalTitle
ModalTitle.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.any,
  disableBtn: PropTypes.bool
}
